module.exports = __webpack_public_path__ + "static/img/04.37a81a6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/02-productCenter-assetsM/04.jpg
// module id = 9mY+
// module chunks = 1